<template>
  <div v-show="isActive" class="tab-content">
    <slot></slot>
  </div>
</template>

<script>
/**
 * Tab usada no componente de Tabs
 */
export default {
  name: 'Tab',
  props: {
    /**
      Título da tab, que aparece nas abas
     */
    title: {
      type: String,
      default: 'Tab Title'
    },
    /**
     * Se true, inicia a tab como ativa
     */
    active: {
      type: Boolean,
      default: false
    },
    /** Dados extras para passar por slot caso necessário */
    extraData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isActive: this.active
    }
  }
}
</script>
